import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-astcontactus',
  templateUrl: './astcontactus.component.html',
  styleUrls: ['./astcontactus.component.scss']
})
export class AstcontactusComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
